import { OpportunityScore } from '../types/opportunity';

export const normalizeScores = (opportunities: OpportunityScore[]) => {
  console.log('Starting score normalization with opportunities:', opportunities);
  
  // Find min and max values for both dimensions
  const valueScores = opportunities.map(opp => opp.valueScore);
  const feasibilityScores = opportunities.map(opp => opp.feasibilityScore);
  
  const minValue = Math.min(...valueScores);
  const maxValue = Math.max(...valueScores);
  const minFeasibility = Math.min(...feasibilityScores);
  const maxFeasibility = Math.max(...feasibilityScores);

  console.log('Score ranges:', {
    value: { min: minValue, max: maxValue },
    feasibility: { min: minFeasibility, max: maxFeasibility }
  });

  // First pass: normalize scores to 0-100 range
  const normalizedScores = opportunities.map(opp => {
    // For value scores, use standard normalization
    const normalizedValue = (opp.valueScore - minValue) / (maxValue - minValue);
    
    // For feasibility scores, we want to invert the scale (since higher challenge scores mean lower feasibility)
    // but maintain the relative distribution
    const normalizedFeasibility = (opp.feasibilityScore - minFeasibility) / (maxFeasibility - minFeasibility);
    
    // Apply tiered transformation to both scores
    const getTierScore = (score: number) => {
      return 20 + score * 80; // Linear scaling from 20-100 range
    };

    return {
      ...opp,
      valueScore: getTierScore(normalizedValue),
      feasibilityScore: getTierScore(normalizedFeasibility)
    };
  });

  // Calculate center of gravity
  const centerOfGravity = {
    value: normalizedScores.reduce((sum, opp) => sum + opp.valueScore, 0) / normalizedScores.length,
    feasibility: normalizedScores.reduce((sum, opp) => sum + opp.feasibilityScore, 0) / normalizedScores.length
  };

  console.log('Center of gravity:', centerOfGravity);

  // Calculate offsets with a stronger centering effect
  const targetCenter = 50; // Center of our 0-100 range
  const valueOffset = (targetCenter - centerOfGravity.value) * 1.2;
  const feasibilityOffset = (targetCenter - centerOfGravity.feasibility) * 1.2;

  // Second pass: apply offsets and ensure scores stay within bounds
  return normalizedScores.map(opp => ({
    ...opp,
    valueScore: Math.max(20, Math.min(100, opp.valueScore + valueOffset)),
    feasibilityScore: Math.max(20, Math.min(100, opp.feasibilityScore + feasibilityOffset))
  }));
};